import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  TextInput
} from "react-admin";
import { perGameCalc, getPerGameStatValue } from "util/stats";
import _ from "lodash";
import { useFormState, useForm } from "react-final-form";

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, "basketball.teamGameCount");
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(`basketball.${updateField}`, perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const stats = _.get(values, "basketball");
    const { totalPoints, rebounds } = stats;
    const pointsPerGame = perGameCalc(totalPoints, value);
    const reboundsPerGame = perGameCalc(rebounds, value);

    form.change("basketball.pointsPerGame", pointsPerGame);
    form.change("basketball.reboundsPerGame", reboundsPerGame);
  };

  return (
    <SimpleShowLayout {...props}>
      <TextField source="basketball.id" />
      <NumberInput source="basketball.seasonWins" />
      <NumberInput source="basketball.seasonLosses" />
      <NumberInput source="basketball.seasonTies" />
      <NumberInput source="basketball.seasonPercentWins" />
      <NumberInput source="basketball.districtWins" />
      <NumberInput source="basketball.districtLosses" />
      <NumberInput source="basketball.districtTies" />
      <NumberInput source="basketball.districtPercentWins" />
      <NumberInput source="basketball.homeWins" />
      <NumberInput source="basketball.homeLosses" />
      <NumberInput source="basketball.homeTies" />
      <NumberInput source="basketball.roadWins" />
      <NumberInput source="basketball.roadLosses" />
      <NumberInput source="basketball.roadTies" />
      <TextInput source="basketball.streak" />
      <NumberInput source="basketball.differential" />
      <NumberInput
        source="basketball.teamGameCount"
        onChange={updateAllRelatedStats}
      />
      <NumberInput
        source="basketball.totalPoints"
        onChange={(e) => updateStat(e, "pointsPerGame")}
      />
      <NumberInput
        source="basketball.pointsAgainst"
        onChange={(e) => updateStat(e, "pointsAgainstPerGame")}
      />
      <NumberInput
        source="basketball.rebounds"
        onChange={(e) => updateStat(e, "reboundsPerGame")}
      />
      <NumberInput
        source="basketball.threePointFieldGoals"
        onChange={(e) => updateStat(e, "threePointFieldGoalsPerGame")}
      />
      <NumberInput source="basketball.pointsPerGame" />
      <NumberInput source="basketball.pointsAgainstPerGame" />
      <NumberInput source="basketball.reboundsPerGame" />
      <NumberInput source="basketball.threePointFieldGoalsPerGame" />
    </SimpleShowLayout>
  );
};

export default FormTab;
